import React, { useEffect, useState } from "react";

import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Icon,
  IconButton,
  Stack,
  Toolbar,
  ThemeProvider,
  Snackbar,
  Alert,
} from "@mui/material";

import { ReactComponent as LogoEasyMapsLigth } from "../../assets/easyMaps/logoEasyMaps.svg";
import easyMapsTheme from "../../themes/easyMapsTheme";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { DarkModeOutlined, LightModeOutlined } from "@mui/icons-material";
import LoadingPage from "../../componentes/loadingPage";
import { socketPublic as socket } from "../../services/socket";
import api from "../../services/apiPublic";

function LayoutEasyMapsPublic(params) {
  const { colorMode, setColorMode, backgroundColor = null } = params;
  const theme = React.useMemo(() => easyMapsTheme(colorMode), [colorMode]);

  const [isConnected, setIsConnected] = useState(socket.connected);
  const [config, setConfig] = useState(null);
  const [configLocal, setConfigLocal] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const [configLayer, setConfigLayer] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);

  const styles = {
    boxMenuAndLogo: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 1,
      paddingX: 3,
      width: "270px",
    },
    toolbar: {
      width: "100%",
      padding: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      paddingX: 1,
    },
    appBar: {
      // /display: "relative",
      minWidth: "350px",
      width: "100%",

      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      position: "sticky",
      top: 0,
      left: 0,
      right: "950",
      bgcolor: backgroundColor
        ? backgroundColor
        : theme.palette.background.paper,
      //border: "none",
      borderBottom: "1px solid " + theme.palette.color.appBarBorder,

      zIndex: 1200,
    },
    icon: {
      width: { xs: "120px", sm: "180px" },
      display: { xs: "none", smd: "flex" },
      height: "50px",
      alignItems: "center",
      justifyContent: "flex-start",
      fill: theme.palette.color.text,
    },
    imgIcon: {
      width: { xs: 10, sm: 170 },
      height: "auto",
      //fill: "white",
      //fill: theme.palette.text.secondary,
    },
    containerLayout: {
      display: "flex",
      width: "100%",
      height: "fit-content",
      flexDirection: "column",
    },
    containerBody: {
      display: "flex",
      width: "100%",
      height: "100%",
      minWidth: "350px",
    },
    containerOutlet: {
      flexGrow: 1,
      //paddingTop: 5, paddingInline: 3

      gap: 3,
    },
    boxRight: {
      display: "flex",
      alignItems: "center",
      gap: { sm: 0, md: "4px" },
    },
  };

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      socket.emit(
        "first_connection",
        `Servidor juntou-se ao grupo id conection: ${socket.id}`
      );
    }
    function onDisconnect() {
      setIsConnected(true);
    }

    function connectErrorEvent(error) {
      console.log("Socket error - erro de conexão:", error);
    }
    function reconnectAttemptEvent(attempt) {
      console.log(
        `Socket warn - o servido esta tentando ser reconectar. N de tentativas: ${attempt}`
      );
    }
    function reconnectErrorEvent(error) {
      console.log("Socket error - erro de reeconexão:", error);
    }
    function reconnectEvent(attempt) {
      console.log("Socket success: servidor reeconectado com sucesso");
    }

    socket.connect();
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", connectErrorEvent);
    socket.io.on("reconnect_attempt", reconnectAttemptEvent);
    socket.io.on("reconnect_error", reconnectErrorEvent);
    socket.io.on("reconnect", reconnectEvent);
    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", connectErrorEvent);
      socket.io.off("reconnect_attempt", reconnectAttemptEvent);
      socket.io.off("reconnect_error", reconnectErrorEvent);
      socket.io.off("reconnect", reconnectEvent);
    };
  }, []);

  useEffect(() => {
    handleApiGetConfig();
  }, []);

  // atualizações do layer nos mapas
  useEffect(() => {
    if (!configLayer) return;
    sessionStorage.setItem("easyMapsLayer", JSON.stringify(configLayer));
  }, [configLayer]);

  useEffect(() => {
    if (configLayer != null) return;
    // Push the object directly
    let layers = sessionStorage.getItem("easyMapsLayer");
    setConfigLayer(JSON.parse(layers));
  }, []);
  // fim da atualização de layeres nos maps

  async function handleApiGetConfig() {
    try {
      const response = await api.post("/settings/public/find", {
        product: "easymaps",
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          let dataConfig = response.data;

          if (
            dataConfig?.configuracoes?.geo?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.geo?.atualizacao
          ) {
            dataConfig.configuracoes.geo.atualizacao = 60000;
          }
          if (
            dataConfig?.configuracoes?.top?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.top?.atualizacao
          ) {
            dataConfig.configuracoes.top.atualizacao = 60000;
          }
          if (
            dataConfig?.configuracoes?.ftth?.atualizacao < 60000 ||
            !dataConfig?.configuracoes?.ftth?.atualizacao
          ) {
            dataConfig.configuracoes.ftth.atualizacao = 60000;
          }
          setConfig({
            id: dataConfig.id,
            configuracoes: dataConfig.configuracoes,
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const clientLogo =
    colorMode === true
      ? `${
          window?.config?.REACT_APP_LOGO_EASY_MAPS_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_EASY_MAPS_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_EASY_MAPS_URL || ""}`;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={styles.containerLayout}>
        <AppBar
          position="fixed"
          sx={styles.appBar}
          elevation={0}
          color="primary"
        >
          <Container maxWidth="100vw">
            <Toolbar sx={styles.toolbar} disableGutters>
              <Box sx={styles.boxMenuAndLogo}>
                {clientLogo ? (
                  <Icon sx={styles.icon}>
                    <img src={clientLogo} style={styles.imgIcon} />
                  </Icon>
                ) : (
                  <Icon sx={styles.icon}>
                    <LogoEasyMapsLigth
                      style={{ width: "180px" }}
                      alt={"mw-logo"}
                    />
                  </Icon>
                )}
              </Box>
              <Box sx={styles.boxRight}>
                <IconButton
                  onClick={() => {
                    if (colorMode) {
                      setColorMode(false);
                      localStorage.setItem(
                        "3",
                        JSON.stringify({ colorMode: false })
                      );
                    } else {
                      setColorMode(true);
                      localStorage.setItem(
                        "3",
                        JSON.stringify({ colorMode: true })
                      );
                    }
                  }}
                >
                  {!colorMode ? <DarkModeOutlined /> : <LightModeOutlined />}
                </IconButton>
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
        <Box sx={styles.containerBody}>
          <Box component="main" sx={styles.containerOutlet}>
            <Outlet
              context={{
                config,
                setConfig,
                configLocal,
                setConfigLocal,
                socket,
                configLayer,
                setConfigLayer,
              }}
            />
          </Box>
        </Box>
      </Box>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transitionDuration={1}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </ThemeProvider>
  );
}

export default LayoutEasyMapsPublic;
